import { FC, useState } from 'react';
import { Button, VStack, useCheckboxGroup, Text } from '@chakra-ui/react';
import { Proposal, VotingSystem } from 'types/snapshot';
import { useWeb3React } from 'hooks/web3';
import { useModal } from 'store/modals';
import { ModalType } from 'components/modals/types';
import CheckboxCard from 'components/shared/CheckboxCard';

type Props = {
  proposal: Proposal;
};

const parseData = (checked: string[], type: VotingSystem) => {
  if (type === VotingSystem.SINGLE_CHOICE) {
    return checked.map(Number)[0];
  } else {
    return checked.map(Number);
  }
};

const SelectForm: FC<Props> = ({ proposal }) => {
  const { openModal } = useModal();
  const { type, choices } = proposal;
  const { account } = useWeb3React();
  const [checked, setChecked] = useState<any[]>([]);

  const { getCheckboxProps } = useCheckboxGroup({
    value: checked,
    onChange: (nextValue) => {
      type === VotingSystem.SINGLE_CHOICE
        ? setChecked(nextValue.filter((x) => !checked.includes(x)))
        : setChecked(nextValue);
    }
  });

  const handleVote = () => {
    openModal(ModalType.vote, {
      proposal,
      data: parseData(checked, type as VotingSystem)
    });
  };

  return (
    <VStack alignItems='stretch' spacing={4}>
      {choices.map((value, idx) => {
        const checkbox = getCheckboxProps({ value: (idx + 1).toString() });
        return (
          <CheckboxCard key={idx + 1} {...checkbox} value={idx + 1}>
            <Text py={2}>{value}</Text>
          </CheckboxCard>
        );
      })}
      <Button
        size='lg'
        disabled={checked.length === 0 && !!account}
        onClick={
          !account ? () => openModal(ModalType.connectWallet) : handleVote
        }
      >
        {!account ? 'Connect Wallet' : 'Vote'}
      </Button>
    </VStack>
  );
};

export default SelectForm;
